import { veraEnabled } from './config'
import createChat from './chat'
import createTakeover from './takeover'
import { resumeWishlistAfterLogin } from './wishlist'

export default function initVeraInstantDiscovery () {
  if (!veraEnabled()) return

  const root = document.querySelector('#vjs-vera-chat')
  const boxes = Array.from(document.querySelectorAll('.vjs-vera-search'))
  if (!root || boxes.length === 0) return

  const page = document.querySelector('.vjs-vera-conversations-page')

  // The conversations page is rendered once: a chat that changed the list reloads it on close.
  const chat = createChat(root, {
    onConversationsChanged: () => {
      takeover.refresh()
      if (!page) return
      if (chat.isOpen) page.dataset.stale = 'true'
      else if (page.dataset.stale) window.location.reload()
    }
  })
  const takeover = createTakeover(boxes, chat)

  page?.addEventListener('click', event => {
    const button = event.target.closest('.vjs-vera-open-chat')
    if (!button) return

    const { conversationId, seedText, entryPoint } = button.dataset
    chat.open({ conversationId, seedText, entryPoint })
  })

  resumeWishlistAfterLogin(chat)
}
